import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { handleAddressCheckStep, handleIsNotAvailableStep, handleResultStep } from "./analytics";
import { getViewStatus } from "../moduleSelectors";
import { selectLink } from "../selectors";
import { ADDRESS_BLOCK_VIEW_STATUSES, AVAILABLE_STEPS_FOR_PHONE_INPUT } from "../constants";
import { IS_BACK_CALL_POPUP_SHOWN } from "../../../constants";
import { checkConnectionAndTariffs } from "./checkConnectionAndTariffs";
import { submitCallbackRequest } from "../../../callbackRequest/actions/submitCallbackRequest";
import { setLoading } from "../slice";
export var handleStepProgress = function handleStepProgress() {
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(dispatch, getState) {
      var state, step, link;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            state = getState();
            step = getViewStatus(state);
            link = selectLink(state);
            if (step === ADDRESS_BLOCK_VIEW_STATUSES.checkAddress) {
              dispatch(handleAddressCheckStep());
              // eslint-disable-next-line @typescript-eslint/no-floating-promises
              dispatch(checkConnectionAndTariffs());
              /** сеттинг флага для отключение самовызывающегося попапа */
              sessionStorage.setItem(IS_BACK_CALL_POPUP_SHOWN, '1');
            }
            if (AVAILABLE_STEPS_FOR_PHONE_INPUT.includes(step)) {
              // eslint-disable-next-line @typescript-eslint/no-floating-promises
              dispatch(submitCallbackRequest());
              dispatch(handleResultStep());
            }
            if (step === ADDRESS_BLOCK_VIEW_STATUSES.isNotAvailable && link) {
              dispatch(handleIsNotAvailableStep({
                isSecondaryButton: false
              }));
              dispatch(setLoading(true));
              window.location.assign(link);
            }
          case 6:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
};